<template>
    <div class="lic-contract">
        <div class="list-controls">
            <div class="gui-form">
                <div class="row-box">
                    <div class="sel-inp-set">
                        <label>팀:</label>
                        <select v-model.number="state.selectedCrewId" @change="onChangeCrew">
                            <option v-for="c in state.crews" :key="c[CREW_KEYS.id]" :value="c[CREW_KEYS.id]">
                                {{ c[CREW_KEYS.name] }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-header">
                <div class="left">
                    <strong>라이선스 계약</strong>
                    <p class="total">총 <span>{{ state.rows.length }}</span>건</p>
                </div>
            </div>

            <div class="table-wrapper">
                <table class="table">
                    <thead>
                        <tr>
                            <th>제품명</th>
                            <th style="width: 160px">수량</th>
                            <th style="width: 160px">만료날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="state.loading.licenses">
                            <td colspan="3" class="empty">라이선스 불러오는 중...</td>
                        </tr>
                        <tr v-else-if="state.rows.length === 0">
                            <td colspan="3" class="empty">데이터가 없습니다.</td>
                        </tr>
                        <tr v-for="row in state.rows" 
                            :key="row.rowKey"
                            class="row-clickable"
                            @click="openContractDetail(row)">
                            <td>{{ row.productName }}</td>
                            <td>{{ row.totalQuantity }}</td>
                            <td>{{ row.endDate ? formatDate(row.endDate) : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'licenseContract',
    data() {
        return {
            CREW_KEYS: { id: 'id', name: 'crewName' },
            state: {
                crews: [],
                selectedCrewId: null,
                loading: { crews: false, licenses: false },
                rows: [],
            },
        };
    },
    methods: {
        onChangeCrew() {
            this.fetchCrewLicenses();
        },
        fetchCrews() {
            this.state.loading.crews = true;
            return new Promise((resolve) => {
                this.axiosCaller.get(
                    this,
                    this.APIs.LICENSE + '/getUserCrewList',
                    {},
                    (result) => {
                        try {
                            const list = this.getSafeArray(result);
                            this.state.crews = list;
                            if (!this.state.selectedCrewId && list.length > 0) {
                                this.state.selectedCrewId = list[0][this.CREW_KEYS.id];
                            }
                        } finally {
                            this.state.loading.crews = false;
                            resolve();
                        }
                    }
                );
            }).then(() => this.fetchCrewLicenses());
        },
        fetchCrewLicenses() {
            if (!this.state.selectedCrewId) { this.state.rows = []; return; }
            this.state.loading.licenses = true;
            this.state.rows = [];
            this.axiosCaller.get(
                this,
                this.APIs.LICENSE + '/getCrewLicenseListForContract',
                { crewId: this.state.selectedCrewId },
                (result) => {
                    try {
                        const data = result?.data || {};
                        if (data.status === 'ok') {
                            const list = this.getSafeArray(result);
                            const mapped = list.map((license) => ({
                                rowKey: `license-${license.id}`,
                                licenseId: license.id,
                                productName: license.productName,
                                totalQuantity: license.quantity,
                                startDate: license.startDate,
                                endDate: license.endDate,
                                clientId: license.clientId,
                            }));
                            // 정렬 (제품명순, 만료일순)
                            this.state.rows = mapped.sort((a, b) => {
                                const productCompare = (a.productName || '').localeCompare(b.productName || '');
                                if (productCompare !== 0) return productCompare;
                                const dateA = a.endDate ? new Date(a.endDate) : new Date(0);
                                const dateB = b.endDate ? new Date(b.endDate) : new Date(0);
                                return dateA.getTime() - dateB.getTime();
                            });
                        } else {
                            this.gritterErr(data.msg || '라이선스 정보 조회 실패');
                            this.state.rows = [];
                        }
                    } finally {
                        this.state.loading.licenses = false;
                    }
                }
            );
        },
        getData(resOrData) { return resOrData?.data ?? resOrData; },
        getSafeArray(resOrData) {
            const result = this.getData(resOrData);
            if (result?.status && result.status !== 'ok') {
                this.gritterErr(result?.msg || '요청이 실패했습니다.');
                return [];
            }
            const topCandidates = [result?.list, result?.rows, result?.content, result?.data];
            for (const v of topCandidates) if (Array.isArray(v)) return v;
            const nestedCandidates = [result?.data?.list, result?.data?.rows, result?.data?.content];
            for (const v of nestedCandidates) if (Array.isArray(v)) return v;
            if (result && typeof result === 'object') {
                for (const k of Object.keys(result)) if (Array.isArray(result[k])) return result[k];
            }
            return [];
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            const d = new Date(dateString);
            return d.toLocaleDateString('ko-KR');
        },
        openContractDetail(row) {
            if (!row.licenseId || !this.state.selectedCrewId) return;
            this.$router.push({
                name: 'contractDetail',
                params: {
                    crewId: this.state.selectedCrewId,
                    licenseId: row.licenseId,
                },
            });
        },
        gritterErr(msg) { const m = msg || '정상적인 접근이 아닙니다. 다시 시도해주세요.'; this.swalUtils?.gritter ? this.swalUtils.gritter('error', m, 'error', 2000) : console.error('[ERR]', m); },
    },
    mounted() {
        this.fetchCrews();
    },
};
</script>

<style scoped>
.muted { color: #666; }
</style>


